import axios from "axios";
export const GetItemData=()=>axios.get(`/api/products`);
  
